//Amnbientes disponibles
const Ambiente = {
    goitDesarrollo: "http://desa.goitsa.me:8080",
    verisDesarrollo: "https://api.phantomx.com.ec",
    verisProduccion: "https://api.phantomx.com.ec",
  };
  //Metodos
  const Metodo = {
    idOrganizacion: "365509c8-9596-4506-a5b3-487782d5876e",
    seguridad: "/seguridad/v1",
    seguridadExt: "/analitica/v1/portal_bi",
    configuracion: "/analitica/v1/portal_bi",
  };
  
  const PROD = {
    seguridad: Ambiente.verisProduccion + Metodo.seguridad,
    seguridadExt: Ambiente.verisProduccion + Metodo.seguridadExt,
    configuracion: Ambiente.verisProduccion + Metodo.configuracion,
    ambiente: Ambiente.verisProduccion,
  };
  const TEST = {
    seguridad: Ambiente.verisDesarrollo + Metodo.seguridad,
    configuracion: Ambiente.verisDesarrollo + Metodo.configuracion,
    seguridadExt: Ambiente.verisDesarrollo + Metodo.seguridadExt,
    ambiente: Ambiente.verisDesarrollo,
  };
  const DESA = {
    seguridad: Ambiente.verisDesarrollo + Metodo.seguridad,
    seguridadExt: "https://analitica.phantomx.com.ec" + Metodo.seguridadExt,
    configuracion:
      "https://analitica.phantomx.com.ec" + Metodo.configuracion,
    //    configuracion: "https://desa-dwh.phantomx.com.ec" + Metodo.configuracion,
  
    ambiente: Ambiente.verisDesarrollo,
  };

  //Solo cambiar por DESA , TEST y PROD
  const UrlServices = DESA;
  
  export default UrlServices;
  